import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-input", // todo: update selector to `lib-input`
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default
})
export class InputComponent {
  @Input() classList = "form-group";
  @Input() inputId = "";
  @Input() innerClassList = "";
  @Input() labelClassList = "";
  @Input() errorClassList = "";
  @Input() icon = "";
  @Input() clickableIconWhenDisabled = false;
  @Input() label = "";
  @Input() placeholder = "";
  @Input() readonly = false;
  @Input() type = "text";
  @Input() mask = "";
  @Input() isRequired = false;
  /** Per-instance validation-error message overrides (error key -> translation key). */
  @Input() customMessages: Record<string, string> = {};
  @Input() control: FormControl | null = null;
  @Input() tooltip = "";
  @Input() iconTooltip = "";
  @Input() trimOnFocusOut = false;

  @Input() set patterns(value: any) {
    if (value) {
      this.customMaskPatterns = value;
    }
  }

  @Output() iconClick = new EventEmitter();
  @Output() focus = new EventEmitter<Event>();
  @Output() blur = new EventEmitter<Event>();

  customMaskPatterns: any;

  onIconClick(): void {
    if (this.control && (this.control.enabled || this.clickableIconWhenDisabled)) {
      this.iconClick.emit();
    }
  }

  onFocusOut(): void {
    if (typeof this.control?.value === "string" && this.trimOnFocusOut) {
      const value = this.control.value.trim();

      this.control.setValue(value, { emitEvent: true });
    }
  }
}
